/**
 * defa.views.ManualZoneForm
 * @version 1.2.1
 */
import Form                  from 'scripts/poppet/form';
import template              from 'scripts/defa/zones/template-zone-manual-form.jst.html';
import { Vue }               from 'vue/defavue';


const ManualZoneForm = Form.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template     : template,
	className    : 'card no-hidden',
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	onAttach: function () {
		this.attachSlider()
	},
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Creates and attaches the slider the slider to the dom.
	 * @void
	 */
	
	attachSlider: function() {
		let self   = this;
		let currentValue = self.getCurrentValue();
		let [ min, max ] = 'regulator' === self.model.getModel( '5' ).get( 'zoneMode' ) ? [ 5, 95 ] : [ -20, 40 ];
		let tempUnit = self.model.tempUnit();
		
		new Vue({
			el: '#manual-components',
			bb() {
				return {
					thermostatModel : self.model.getModel( '3' ),
					regulatorModel  : self.model.getModel( '4' ),
					heatingZoneModel: self.model.getModel( '5' ),
					onOffModel: self.model.getModel( '1' )
					
				};
			},
			data() {
				return {
					currentLevelValue: currentValue,
					tempUnit,
					min,
					max,
					locked: !self.options.enabled,
				};
			},
			
			methods: {
				updateModels() {
					self.updateModels(this.value);
				},
				
				save: function () {
					let data = {};
					let savingValue = parseInt(this.currentLevelValue);
					switch (this.mode) {
						case 'regulator':
							data.currentLevel = savingValue;
							self.saveModel('4', data);
							break;
						case 'thermostat':
							if ( this.onOffModel.onOff ) {
								data.currentCoolingSetpoint = savingValue;
								data.currentHeatingSetpoint = savingValue -1;
							} else {
								data.currentHeatingSetpoint = savingValue;
								data.currentCoolingSetpoint = savingValue + 2;
							}
							self.saveModel('3', data);
							break;
					}
				},
			},
			
			computed: {
				disableSlider : function () {
					return this.locked || null === this.heatingZoneModel.zoneMode || null === this.currentValue || null === this.onOffModel.onOff
				},
				modelError: function () {
					if('regulator' === this.heatingZoneModel.zoneMode) {
						return this.regulatorModel.modelError
					} else if ('thermostat' === this.heatingZoneModel.zoneMode ){
						return this.thermostatModel.modelError
					}
					return ''
				},
				currentValueError: function () {
					if('regulator' === this.heatingZoneModel.zoneMode) {
						return this.regulatorModel.currentLevelError
					} else if ('thermostat' === this.heatingZoneModel.zoneMode ){
						return this.onOffModel.onOff
							   ? this.thermostatModel.currentCoolingSetpointError
							   : this.thermostatModel.currentHeatingSetpointError
					}
					return null
				},
				modeError: function () {
					return null === this.heatingZoneModel.zoneMode ? this.heatingZoneModel.modelError ||this.heatingZoneModel.zoneModeError : null;
				},
				onOffError: function () {
					return null === this.onOffModel.onOff ? this.onOffModel.modelError ||this.onOffModel.onOffError : null;
				},
				mode: function () {
					return this.heatingZoneModel.zoneMode
				}
			},
			watch : {
				'regulatorModel.currentLevel' : function (newValue){
					if('regulator' === this.mode){
						this.currentLevelValue = newValue;
					}
				},
				'thermostatModel.currentCoolingSetpoint' : function (newValue) {
					if ( 'thermostat' === this.mode ) {
						if(this.onOffModel.onOff){
							this.currentLevelValue = newValue;
						}
					}
				},
				'thermostatModel.currentHeatingSetpoint' : function (newValue) {
					if ( 'thermostat' === this.mode ) {
						if(!this.onOffModel.onOff){
							this.currentLevelValue = newValue;
						}
					}
				}
			}
		});
	},
	
	/**
	 * Saves a model to backend.
	 * @void
	 */
	saveModel: function ( model, attrs) {
		let self = this;
		self.busy();
		try {
			self.model.getModel(model).save( attrs, {
				patch: true,
				isSaving: true,
				success: function () {
					console.log( 'Model was saved!' );
					self.idle();
				},
				error  : function () {
					console.error( 'Model failed at saving...' );
					self.idle();
				}
			} );
		} catch ( err ) {
			console.error( err );
			setTimeout( () => this.idle(), 1000 );
		}
	},
	
	/**
	 * Returns the current temperature.
	 */
	getCurrentValue: function () {
		switch ( this.model.getModel( '5' ).get( 'zoneMode' ) ) {
			case 'regulator':
				return this.model.getModel( '4' ).get( 'currentLevel' );
			case 'thermostat':
				return this.model.getTargetTemperature();
		}
		return '';
	},
	
} );


export default ManualZoneForm;
